import { render, staticRenderFns } from "./RiskScanUpdate.vue?vue&type=template&id=11b08564&scoped=true&"
import script from "./RiskScanUpdate.vue?vue&type=script&lang=js&"
export * from "./RiskScanUpdate.vue?vue&type=script&lang=js&"
import style0 from "./RiskScanUpdate.vue?vue&type=style&index=0&id=11b08564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b08564",
  null
  
)

export default component.exports